import styled from 'styled-components';

const StyledContainer = styled.div`  
    .hidden { display: none; }  
    .save-button {
        flex-direction: row-reverse;
    }
    
    .ant-breadcrumb-link a {
        color: ${props => props.primaryColor} !important;
        opacity: 0.7;
    }
    
    .steps-action {
        padding-top: 15px;
    }
`;

export default StyledContainer;